import { ICommonTranslations } from '@/translations/default/common';

const common: Partial<ICommonTranslations> = {
  product_interactions: 'Product interactions',
};

export default common;
